// extracted by mini-css-extract-plugin
export var badgeDisrupted = "luas-travel-update-module-module--badgeDisrupted--975c4";
export var badgeNormal = "luas-travel-update-module-module--badgeNormal--56c78";
export var bulletin = "luas-travel-update-module-module--bulletin--19a01";
export var bulletinHeading = "luas-travel-update-module-module--bulletinHeading--505d6";
export var bulletinWrapper = "luas-travel-update-module-module--bulletinWrapper--85c32";
export var error = "luas-travel-update-module-module--error--768a5";
export var greenLine = "luas-travel-update-module-module--greenLine--82335";
export var lineMessage = "luas-travel-update-module-module--lineMessage--12332";
export var lineName = "luas-travel-update-module-module--lineName--288d0";
export var lineStatus = "luas-travel-update-module-module--lineStatus--635f5";
export var lineStatuses = "luas-travel-update-module-module--lineStatuses--88435";
export var loading = "luas-travel-update-module-module--loading--22f6c";
export var page = "luas-travel-update-module-module--page--68045";
export var redLine = "luas-travel-update-module-module--redLine--f5bfd";
export var title = "luas-travel-update-module-module--title--007bc";